export const messages = {
  configurePageTitle: 'Configure Reward',
  updatePageTitle: 'Update Reward',
  subtitle: 'Drive return visits through members spending points on fuel, products and services',
};
